module.exports = __webpack_public_path__ + "media/images/brasao-hor-neg-31fc51eb2e7920f025695a4fb123b76d.svg";